import * as React from "react";

/**
 * Email link properties.
 */
export interface IEmailLinkProps {
  /** Email address. */
  email?: string;
  /** Subject to include to mailto link. */
  subject?: string;
}

/**
 * Email link with optional subject.
 */
export function EmailLink(props: IEmailLinkProps) {
  const subjectURI = props.subject
    ? `?subject=${encodeURIComponent(props.subject)}`
    : "";
  return <a href={`mailto:${props.email}${subjectURI}`}>{props.email}</a>;
}
